import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { RealtimeProvider } from './contexts/RealtimeContext';
import { LocationProvider } from './contexts/LocationContext';
import { AriaProvider } from './contexts/AriaContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import ControlTower from './pages/ControlTower';
import Customers from './pages/Customers';
import Products from './pages/Products';
import Factory from './pages/Factory';
import Quality from './pages/Quality';
import Inventory from './pages/Inventory';
import Dispatch from './pages/Dispatch';
import DispatchPlan from './pages/DispatchPlan';
import Finance from './pages/Finance';
import VendorsPage from './pages/VendorsPage';
import CarriersPage from './pages/CarriersPage';
import ServiceProvidersPage from './pages/ServiceProvidersPage';
import PurchasingPage from './pages/PurchasingPage';
import SalesOrders from './pages/SalesOrders';
import Genealogy from './pages/Genealogy';
import Settings from './pages/Settings';
import Users from './pages/Users';
import WhatsApp from './pages/WhatsApp';
import MasterTables from './pages/MasterTables';
import AuditLog from './pages/AuditLog';
import CompanyProfile from './pages/CompanyProfile';
import Locations from './pages/Locations';
import InvoiceCreate from './pages/InvoiceCreate';

function LoadingScreen() {
  return (
    <div style={{ background: 'hsl(0,0%,3%)', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ fontFamily: "'Clash Display', sans-serif", color: 'hsl(197,100%,48%)', fontSize: 24, letterSpacing: '0.2em', textTransform: 'uppercase' }}>
        ARIA FORGE
      </div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <AriaProvider>
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<ControlTower />} />
        <Route path="customers" element={<Customers />} />
        <Route path="products" element={<Products />} />
        <Route path="factory" element={<Factory />} />
        <Route path="quality" element={<Quality />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="dispatch" element={<Dispatch />} />
        <Route path="dispatch-plan" element={<DispatchPlan />} />
        <Route path="orders" element={<SalesOrders />} />
        <Route path="finance" element={<Finance />} />
        <Route path="finance/invoices/new" element={<InvoiceCreate />} />
        <Route path="procurement">
          <Route index element={<Navigate to="vendors" replace />} />
          <Route path="vendors" element={<VendorsPage />} />
          <Route path="carriers" element={<CarriersPage />} />
          <Route path="services" element={<ServiceProvidersPage />} />
          <Route path="purchasing" element={<PurchasingPage />} />
        </Route>
        <Route path="genealogy" element={<Genealogy />} />
        <Route path="settings" element={<Settings />} />
        <Route path="users" element={<Users />} />
        <Route path="audit-log" element={<AuditLog />} />
        <Route path="whatsapp" element={<WhatsApp />} />
        <Route path="masters" element={<MasterTables />} />
        <Route path="company-profile" element={<CompanyProfile />} />
        <Route path="locations" element={<Locations />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
    </AriaProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <RealtimeProvider>
        <LocationProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </LocationProvider>
      </RealtimeProvider>
    </AuthProvider>
  );
}
